import { render, staticRenderFns } from "./system-auth.vue?vue&type=template&id=43ab95a7&scoped=true"
import script from "./system-auth.vue?vue&type=script&lang=js"
export * from "./system-auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab95a7",
  null
  
)

export default component.exports